import IMask from 'imask'
import TimeAgo from 'javascript-time-ago'
import es from 'javascript-time-ago/locale/es-VE.json'
import { DateTime } from 'luxon'
import { IItemPurchase, IItemToLoad, IPhone, IUnit } from 'safe'
import { AccountType } from '../views/Administration/PaymentOrders'

/**
 * Función utilizada para transformar y formatear fechas
 * para su correcto renderizado
 * @param {string} oldDate fecha para transformar
 * @return {string} retorna la fecha transformada con /
 * @example 2022-01-07T04:00:00.000Z -> 07/01/2022
 */
export const transformDate = (
  oldDate: string,
  withZeros: boolean = true
): string => {
  // const localDate = new Date(oldDate)
  // const date = localDate.getDate()
  // const month = localDate.getMonth() + 1
  // const year = localDate.getFullYear()
  // if (withZeros) {
  //   return `${date < 10 ? `0${date}` : date}/${
  //     month < 10 ? `0${month}` : month
  //   }/${year}`
  // }
  // return `${date < 10 ? `${date}` : date}/${
  //   month < 10 ? `${month}` : month
  // }/${year}`
  //  return DateTime.fromISO(oldDate).toLocaleString({
  //   day: '2-digit',
  //   month: '2-digit',
  //   year: 'numeric',
  // })
  /** Se hace esta lógica ya que luxon no contempla la irregularidad de fechas */
  let date = new Date(oldDate)
  date.setHours(date.getHours() + 4)
  date = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  return DateTime.fromISO(date.toISOString()).setLocale('es').
  toLocaleString({
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

//Ejemplo: 19/08/2022
export const dateToDB = (date: string) => {
  let [days, months, year] = date.split('/')
  // console.log("days", days)
  // console.log("months", months)
  // console.log("year..", year)
  // return `${year}-${+months < 10 ? `0${months}` : months}-${+days < 10 ? `0${days}` : days}`
  return `${year}-${months}-${days}`
}

/**
 * Función utilizada para realizar condicional y mostrar el tipo
 * que se requiere.
 * @param {string} status
 * @return {string} retorna el status en mayuscula.
 * @example PENDING ---> PENDIENTE
 */
export const getSellStatus = (status: string): string => {
  if (status === 'PENDING') return 'PENDIENTE'
  if (status === 'COMPLETE') return 'COMPLETADA'
  return 'SIN DEFINIR'
}

export const getTime = (
  oldDate: string,
  isTwelveHours: boolean = false,
  withoutTimeZone: boolean = true
): string => {
  const localDate = new Date(oldDate)
  const hours = localDate.getHours()
  const minutes = localDate.getMinutes()
  let hourFormatted = localDate.toLocaleString('en-US', {
    hour: 'numeric',
    hour12: true,
  })
  return `${isTwelveHours ? hourFormatted.replace(/PM|AM|\s/g, '') : hours}:${
    minutes < 10 ? `0${minutes}` : minutes
  } ${withoutTimeZone ? hourFormatted.replace(/\d+\s/g, '') : ''}`
}

export const transformTime = (time: string): string => {
  return (time.match(/(?<=T)\d.+\d(?=:)/) || '')[0]
}

/**
 * Función utilizada para realizar un formateo de fechas a horas.
 * @param {string} time
 * @return {string} retorna la hora con sus minutos.
 * @example 2022-01-07T15:40:32.045Z --> 11:40
 */
export const transformTimeBySpaces = (time: string): string => {
  return (time.match(/\d+:\d+/) || '')[0]
}

export const formatAMP = (date) => {
  let [hours, minutes] = date.split(':')
  // var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  var strTime = hours + ':' + minutes
  return strTime
}

/**
 * Función utilizada para realizar un formateos de montos tomando en cuenta
 * las comas y puntos dependiendo del tipo de unidad.
 * @param {string|number} amount @param {IUnit} unit
 * @return {string} retorna el formateo concatenado con el tipo de unidad
 * @example (497, {id: '1', name: 'UNIDAD', abbreviatedName: 'und'}) ---> 497 und
 */
export const formatAmount = (amount: string | number, unit: IUnit): string => {
  const { id, abbreviatedName } = unit
  const localAmount = Number(amount)
  if (id === '1') return String(Math.round(localAmount)) + ' ' + abbreviatedName
  return (
    (Number(amount).toFixed(3) + '').replace(
      /(?<=.\d)0{2}|(?<=.\d{2})0|\.0{3}/g,
      ''
    ) +
    ' ' +
    abbreviatedName
  )
}

/**
 * Función utilizada para realizar un formateos de montos tomando en cuenta
 * las comas y puntos dependiendo del tipo de unidad sin retornar la unidad, solo el monto.
 * @param {string|number} amount @param {IUnit} unit
 * @return {string} retorna el monto formateado
 * @example (497, {id: '1', name: 'UNIDAD', abbreviatedName: 'und'}) ---> 497
 */
export const formatAmountWithoutUnit = (
  amount: string | number,
  unit: IUnit
): string => {
  const { id } = unit
  const localAmount = Number(amount)
  if (id === '1') return String(Math.round(localAmount))
  return (Number(amount).toFixed(3) + '').replace(
    /(?<=.\d)0{2}|(?<=.\d{2})0|\.0{3}/g,
    ''
  )
}

/**
 * Función utilizada para realizar un formateo de la fecha y retornar un array de
 * año, mes y dia.
 * @param {string} date
 * @return {number[]} retorna un arreglo de numeros con la fecha.
 * @example 20/1/2022 ---> [2022, 1, 20]
 */
export const getYearMonthAndDay = (date: string): number[] => {
  const splitedDate = date.split('/')
  if (splitedDate.length === 0) {
    return [0, 0, 0]
  }
  const year = Number(splitedDate[2])
  const month = Number(splitedDate[1]) - 1
  const day = Number(splitedDate[0])
  return [year, month, day]
}

export const getISOtime = (date: string): string => {
  const [year, month, day] = getYearMonthAndDay(date)
  const target = new Date(year, month, day)
  return target.toISOString()
}

export const getLocationExistenceValue = () => {
  return {
    0: (value) => (value === '0' ? 'Sin artículos' : `${value} Artículo`),
    1: (value) => `${value} Artículos`,
  }
}

/**
 * Función utilizada para realizar un formateo de la fecha y retornar hace
 * cuanto fue.
 * @param {string} date
 * @return {any} retorna una etiqueta 'div' para inyectarla directamente en react.
 * @example 2022-01-07T15:40:32.045Z ---> hace 20 segundos.
 */
export const formatter = (date) => {
  TimeAgo.setDefaultLocale(es.locale)
  TimeAgo.addLocale(es)
  let timeAgo = new TimeAgo('es')
  return <>{timeAgo.format(new Date(date))}</>
}

/**
 * Función utilizada para realizar un formateo del tipo para cambiar valor.
 * @param {string} type
 * @return {string} retorna el tipo dentro de la condicional.
 * @example CASH ---> EFECTIVO
 */
export const getAccountType = (
  type: 'CASH' | 'BANK_ACCOUNT' | 'OTHER'
): string => {
  if (type === 'CASH') return 'EFECTIVO'
  if (type === 'BANK_ACCOUNT') return 'CUENTA BANCARIA'
  if (type === 'OTHER') return 'BILLETERA'
  return 'TIPO DE CUENTA NO DEFINIDO'
}

/**
 * Función utilizada para realizar un formateo del tipo para cambiar valor.
 * @param {string} type
 * @return {string} retorna el tipo dentro de la condicional.
 * @example CHECKING --> CORRIENTE
 */
export const getBankAccountType = (
  type: 'CHECKING' | 'SAVING' | undefined
): string => {
  if (type === 'CHECKING') return 'CORRIENTE'
  if (type === 'SAVING') return 'AHORROS'
  return 'TIPO DE CUENTA BANCARIA NO DEFINIDO'
}

/**
 * Función utilizada para saber si hay valor o sumando de uno en uno.
 * @param {string} items
 * @return {string|number} retorna la suma en los valores missing.
 */
export const getMissing = (
  items: IItemPurchase[] | IItemToLoad[] | undefined
) => {
  if (!items) {
    return 'No data'
  }
  let missing = 0
  for (const item of items) {
    if (Number(item.missing) > 0) missing++
  }
  return missing
}

export const returnCategoryString = (category): string => {
  let transform = {
    name: 'Nombre',
    description: 'Descripcion',
    code: 'Codigo',
    children: 'Subcategorias',
  }
  let catString = Object.keys(category).reduce((a, b) => {
    if (transform[b]) {
      if (b === 'children') {
        return `${a}${['', transform[b] + ':'][+(category[b].length > 0)]}${
          category[b]
            .map((v) => {
              return Object.keys(v).reduce((x, y) => {
                if (transform[y])
                  return (
                    x +
                    `\n ${y === 'name' ? '* ' : '  '}${transform[y]} ${v[y]}`
                  )
                return x
              }, '')
            })
            .join('\n\t\t\t\t') || 'No hay subcategorias'
        }`
      }
      return a + `${transform[b]} : ${category[b]} \n`
    }
    return a
  }, '')
  return catString
}

/** 
 * Función utilizada para renderizar de manera transformada un tipo de articulo junto con su estilo.
 * @param {string} type
 * @return {Object} retorna el tipo transformado.
 * @example ASSEMBLY ---> {value: 'Ensamblado',
      style: 'text-primaryOrange'}
 */
export const getItemType = (type: string): { value: string; style: string } => {
  console.log('type...', type)
  const objTransform = {
    RAW_MATERIAL: {
      value: 'Materia Prima',
      style: 'text-primaryOrange',
    },
    FINISHED_PRODUCT: {
      value: 'Producto terminado',
      style: 'text-success-dark',
    },
    COMPOUND: {
      value: 'Compuesto',
      style: 'text-primary-300',
    },
    MERCHANDISE: {
      value: 'Mercancia',
      style: 'text-warning',
    },
    INDIRECT_SUPPLY: {
      value: 'Suministro indirecto',
      style: 'text-primaryGreen',
    },
    OFFICE_SUPPLY: {
      value: 'Suministro de oficina',
      style: 'text-danger',
    },
    OTHER: {
      value: 'Otro',
      style: 'text-primary-300',
    },
  }

  // if (!(type in objTransform)) throw new Error('Propiedad no existente')
  return objTransform[type]
}

export const formatToBs = (money: number | string): string => {
  return (+money).toFixed(2) + ' Bs'
}

export function translateAccountType(title: string): AccountType {
  if (title === 'Cuentas Nacionales') return 'national'
  if (title === 'Pago movil') return 'instantPayment'
  if (title === 'Otros') return 'other'
  return 'unknown'
}

export function translateAccountTypeToSpanish(title: AccountType): string {
  if (title === 'national') return 'Cuentas Nacionales'
  if (title === 'instantPayment') return 'Pago movil'
  if (title === 'other') return 'Otros'
  return 'desconocido'
}

/**
 * Función utilizada para revisar si hay dos números como minimo repetidos y lanzar mensaje de error.
 * @param {IPhone[]} phones
 * @return {boolean} retorna un booleano.
 * @example [{number: '041460'}, {number: '041460'}] ---> true,
 */
export function checkDoublePhones(phones: IPhone[]): boolean {
  return phones.some(
    (v) => phones.filter((phone) => phone.number === v.number).length > 1
  )
}

export const getIvaNumber = (
  ivaType: 'GENERAL' | 'REDUCED' | 'SUMPTUARY' | 'EXEMPT'
): number => {
  return {
    GENERAL: 1.16,
    REDUCED: 1.08,
    SUMPTUARY: 1.15,
    EXEMPT: 1,
  }[ivaType]
}

export const getDenomination = (idCurrency: string): string | undefined => {
  return {
    '1': '$',
    '2': 'Bs',
    '3': '€',
    '4': 'COP',
  }[idCurrency]
}

export const formatPipe = (value:  string, unMaskValue : boolean = false, decimals: number = 2, min = 0) : any => {
  let unMask = unMaskValue ? [IMask.PIPE_TYPE.UNMASKED,
    IMask.PIPE_TYPE.TYPED] : []

  // Normalizar valores del backend: convertir punto decimal (US format) a coma (Latin format)
  // Solo si NO estamos unmasking y el valor NO tiene coma (indica valor raw del backend)
  if (!unMaskValue && typeof value === 'string' && !value.includes(',')) {
    value = value.replace('.', ',')
  }

  value = unMaskValue ? value.replace(/\./g, "") : value
  let numberPipe = IMask.createPipe({
    mask: Number,
    thousandsSeparator: '.',
    radix: ',',
    scale: decimals,
    normalizeZeros: true,
    padFractionalZeros: decimals > 0,
    min
  },
  ...unMask
  )
  // IMask().un
  return numberPipe(value+"")
}

/** Util que retorna un booleano para chequear si nevula es utilizable o no
 * por medio de date.
 * Esto bloquea nevula el primero de cada mes entre las 12 y 12:20 am
 */
export const isNevulaDisabled = () : boolean => {
  /** Referencia para probar */
  // let date = new Date(2022, 10, 31, 0, 25, 0)
  let date = new Date()
  return date.getDate() === 1 && date.getHours() === 0 && date.getMinutes() >= 0 && date.getMinutes() <= 25
}

/**
 * Calcula la próxima fecha de vencimiento de una suscripción basada en la frecuencia
 * @param {string} currentEndDate - Fecha actual de vencimiento en formato YYYY-MM-DD
 * @param {string} frequency - Frecuencia de la suscripción: 'monthly', 'weekly', 'biweekly', 'quarterly', 'annual'
 * @return {string} Nueva fecha de vencimiento en formato YYYY-MM-DD
 * @example calculateNextSubscriptionDate('2025-10-20', 'monthly') -> '2025-11-20'
 */
export const calculateNextSubscriptionDate = (
  currentEndDate: string,
  frequency: string
): string => {
  const date = DateTime.fromISO(currentEndDate)

  let newDate: DateTime

  switch (frequency) {
    case 'monthly':
      newDate = date.plus({ months: 1 })
      break
    case 'weekly':
      newDate = date.plus({ days: 7 })
      break
    case 'biweekly':
      newDate = date.plus({ days: 14 })
      break
    case 'quarterly':
      newDate = date.plus({ months: 3 })
      break
    case 'annual':
      newDate = date.plus({ years: 1 })
      break
    default:
      // Si la frecuencia no es válida, retornar la fecha actual sin cambios
      newDate = date
      break
  }

  // Retornar en formato YYYY-MM-DD
  return newDate.toISODate()
}